// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__11zDc","label":"Radio_label__3T8rY","checkMark":"Radio_checkMark__15lYT","disabled":"Radio_disabled__1qn6W"};